import { render, staticRenderFns } from "./TeamMenuActivator.vue?vue&type=template&id=b13abf72&"
import script from "./TeamMenuActivator.vue?vue&type=script&lang=js&"
export * from "./TeamMenuActivator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports